let shouldPlay = true;
let muted = true;

const VideoSpots = class extends HTMLElement {
  connectedCallback() {
    this.initVideoLoop();

    const carouselElement = this.querySelector("[data-carousel]");
    const carousel = themeVendor.Flickity.data(carouselElement);

    carousel.on("staticClick", (event, pointer, cellElement, cellIndex) =>
      this.openOverlay(cellIndex)
    );
  }

  initVideoLoop() {
    const videos = Array.from(this.querySelectorAll("[data-carousel] video"));

    const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const loop = async () => {
      for (let i = 0; i <= videos.length - 1; i++) {
        if (shouldPlay) {
          videos[i].play();
        }

        await timeout(5000);

        videos[i].pause();
        videos[i].currentTime = 0;

        if (i == videos.length - 1) {
          loop();
        }
      }
    };

    loop();
  }

  openOverlay(index) {
    if (Number.isNaN(index) || index == undefined) {
      return;
    }

    const mql = window.matchMedia("(max-width: 1023px)");
    if (mql.matches) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    }

    shouldPlay = false;
    const allVideos = document.querySelectorAll(".video-spot video");
    allVideos.forEach((video) => {
      video.pause();
    });

    let overlay = document.querySelector(".video-spot__overlay");

    if (!overlay) {
      overlay = this.createOverlay();
      this.addIntersectionObservers(overlay);
      this.setupOverlayEvents(overlay);
    }

    const videos = overlay.querySelectorAll("video");

    this.goToAndPlay(videos, index, "instant");
  }

  playNext = (overlay, videos, onlyLast = false) => {
    const index = Array.from(videos).indexOf(overlay.querySelector('[data-current="true"]'));
    const nextIndex = index + 1 < videos.length ? index + 1 : 0;

    if (onlyLast) {
      if (nextIndex == 0) {
        this.goToAndPlay(videos, nextIndex);
      }
    } else {
      this.goToAndPlay(videos, nextIndex);
    }
  };

  createOverlay() {
    const template = this.querySelector("template");
    const clone = template.content.cloneNode(true);
    document.body.appendChild(clone);

    const overlay = document.querySelector(".video-spot__overlay");
    const videos = overlay.querySelectorAll("video");

    const next = overlay.querySelector("[data-next]");

    next.addEventListener("click", () => this.playNext(overlay, videos));

    const mute = overlay.querySelector("[data-mute]");
    const unmute = overlay.querySelector("[data-unmute]");

    mute.addEventListener("click", () => {
      overlay.querySelector('[data-current="true"]').muted = true;
      muted = true;
      mute.hidden = true;
      unmute.hidden = false;
    });

    unmute.addEventListener("click", () => {
      overlay.querySelector('[data-current="true"]').muted = false;
      muted = false;
      mute.hidden = false;
      unmute.hidden = true;
    });

    return overlay;
  }

  addIntersectionObservers(overlay) {
    const videos = overlay.querySelectorAll("video");

    videos.forEach((video) => {
      const options = {
        threshold: 0.5,
      };

      const intersectionCallback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!entry.target.src) {
              if (entry.target.dataset.src.includes("m3u8")) {
                const hls = new Hls();
                hls.loadSource(entry.target.dataset.src);
                hls.attachMedia(entry.target);
                hls.on(Hls.Events.MANIFEST_PARSED, () => entry.target.play());
                entry.target.muted = muted;
              } else {
                entry.target.src = entry.target.dataset.src;
                entry.target.play();
                entry.target.muted = muted;
              }
            } else {
              entry.target.play();
            }

            videos.forEach((vid) => (vid.dataset.current = false));
            entry.target.dataset.current = true;
          }
        });
      };

      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(video);
    });
  }

  setupOverlayEvents(overlay) {
    const abortController = new AbortController();

    const videos = overlay.querySelectorAll("video");

    let touchstartY = 0;
    let touchendY = 0;

    const checkDirection = () => {
      if (touchendY < touchstartY) {
        this.playNext(overlay, videos, true);
      }
    };

    overlay.addEventListener(
      "touchstart",
      (e) => {
        touchstartY = e.changedTouches[0].screenY;
      },
      { signal: abortController.signal }
    );

    overlay.addEventListener(
      "touchend",
      (e) => {
        touchendY = e.changedTouches[0].screenY;
        checkDirection();
      },
      { signal: abortController.signal }
    );

    const closeButton = overlay.querySelector(".video-spot__close");
    closeButton.addEventListener("click", () => {
      shouldPlay = true;
      overlay.remove();
      abortController.abort();

      document.body.style.touchAction = "";
      document.body.style.overflow = "";
    });

    videos.forEach((video, idx) => this.setupVideoEvents(video, idx, videos));
  }

  setupVideoEvents(video, index, videos) {
    const progressBar = video.parentElement.querySelector(".progress-bar");

    video.addEventListener("timeupdate", () => {
      const progress = (video.currentTime / video.duration) * 100;
      progressBar.style.width = `${progress}%`;
    });

    video.addEventListener("ended", () => {
      video.pause();
      video.currentTime = 0;
      video.dataset.current = false;
      const nextIndex = index + 1 < videos.length ? index + 1 : 0;
      this.goToAndPlay(videos, nextIndex, nextIndex == 0 ? "instant" : "smooth");
    });
  }

  goToAndPlay(videos, index, behavior = "smooth") {
    videos.forEach((video, idx) => {
      if (idx !== index) {
        video.pause();
        video.currentTime = 0;
      } else {
        video.scrollIntoView({ behavior: behavior });
      }
    });
  }
};

if (!customElements.get("video-spots")) {
  customElements.define("video-spots", VideoSpots);
}
